import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {CampaignsFilter, SortOptions} from 'shared-lib';

interface CampaignsFilterState {
  filter: CampaignsFilter;
}

const initialState: CampaignsFilterState = {
  filter: {
    sort: SortOptions.MOST_RECENT,
  } as CampaignsFilter
};

export const CampaignsFilterStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withMethods((store) => ({
    updateValue(filter: CampaignsFilter) {
      patchState(store, {filter});
    }
  }))
);

export type FilterCampaignsStore = InstanceType<typeof CampaignsFilterStore>;
